export const QUARTZ_GRID_LAYOUT_CLASS = 'quartz-grid-layout';
export const QUARTZ_APP_CONTAINER_CLASS = 'quartz-grid-app-container';
export const QUARTZ_SIDEBAR_CONTAINER_CLASS = 'quartz-grid-sidebar-container';
export const PANEL_WITH_SCROLL_CLASS = 'with-quartz-scroll-panel';
export const PANEL_WITH_SCROLL_LEFT_CLASS = 'with-quartz-scroll-panel-left';
export const SIDEBAR_CLASS = 'with-quartz-sidebar';
export const SIDEBAR_LEFT_CLASS = 'with-quartz-sidebar-left';